import { LinkButton } from "../../../../atoms/link-button";
import * as React from "react";
import {
  ApplicationEntity,
  ContentModified,
  displayModificationType,
} from "@graffer-inc/cloud-gov-core";
import { ApplicationHistoryModal } from "../../../../organisms/smart-apply/modals/application-history-modal";
import { ApplicationHistory } from "../../../../../application/domain/application/application-history";
import { useModal } from "../../../../../utils/custom-hooks";
import { ProcedureEntity } from "../../../../../application/domain/procedures/procedure-entity";

export const ContentModifiedView: React.FC<{
  event: ContentModified;
  procedure: ProcedureEntity;
  previous: ApplicationHistory;
  history: ApplicationHistory;
  application: ApplicationEntity;
}> = ({ event, procedure, previous, history, application }) => {
  const historyModal = useModal();

  return (
    <>
      <p className="has-text-weight-bold">
        「{displayModificationType(event.data.type)}{" "}
        」により申請内容を訂正しました。
      </p>
      <p className="has-text-weight-normal mt-2">
        <LinkButton
          className="button is-rounded is-small"
          onClick={historyModal.open}
        >
          内容を確認
        </LinkButton>
      </p>
      {historyModal.isActive && (
        <ApplicationHistoryModal
          history={history}
          previous={previous}
          procedure={procedure.published!}
          onClose={historyModal.close}
          application={application}
        />
      )}
    </>
  );
};
